var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0H0V14.5C0 14.5 0 14.5 0 14.5V15H0.497812C0.498541 15 0.499271 15 0.500001 15H14.5C14.5007 15 14.5015 15 14.5022 15H15V14.501C15 14.5013 15 14.5007 15 14.501L15 2.5C15 2.28265 14.8596 2.09019 14.6526 2.02386C14.4456 1.95752 14.2195 2.03252 14.0931 2.20939L9.49016 8.65355L6.9 5.2C6.80264 5.07019 6.64833 4.99569 6.48613 5.0002C6.32392 5.0047 6.17399 5.08764 6.08398 5.22265L1 12.8486V0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.a0b60f0f02d9b4ed2e525f27f38308c6.svg";
export { ForwardRef as ReactComponent };